<template>
	<div @click="$emit('click')" class="r2 pt3 pb3 cu2 case-management-value">
		<slot></slot>
	</div>
</template>

<script>
export default {}
</script>

<style scoped>
.case-management-value {
	background-color: rgba(0, 0, 0, 0);
}

.case-management-value:hover {
	background-color: rgba(0, 0, 0, 0.06);
}
</style>
